import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { InputAdornment, TextField } from "@mui/material";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import MDTypography from "../MDTypography";
import pxToRem from "../../Asset/theme/functions/pxToRem";
interface IMDate {
  name: string;
  onChange: any;
  disabled?: boolean;
  defaultValue?: any;
  value?: any;
  label: any;
  error?: boolean | undefined;
  helperText?: string | false | undefined;
  portal?: boolean;
  [otherProps: string]: unknown;
}
export default function MDDate({ defaultValue, value, label, name, onChange, disabled = false, error, helperText, portal = false, ...otherProps }: IMDate) {
  const digits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const dateObject = new DateObject({ calendar: persian, locale: persian_fa });
  const displayValue = value !== undefined ? value : defaultValue;

  return (
    <>
      <DatePicker
        calendar={persian}
        locale={persian_fa}
        portal={portal}
        digits={digits}
        weekDays={weekDays}
        format="YYYY-MM-DD"
        onChange={(e: any) => {
          if (!e) {
            onChange("");
          } else if (typeof e.format === "function") {
            onChange(e.format("YYYY-MM-DD", ["Date", "Time"]));
          } else {
            onChange(String(e));
          }
        }}
        value={displayValue}
        zIndex={9999}
        disabled={disabled}
        render={(value: any, openCalendar: any) => {
          return (
            <TextField
              value={value}
              fullWidth
              error={error}
              name={name}
              onClick={openCalendar}
              id="input-with-icon-textfield"
              label={label}
              autoComplete={"off"}
              disabled={disabled}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CalendarMonthIcon />
                  </InputAdornment>
                ),
              }}
              {...otherProps}
            />
          );
        }}
      />
      {error && (
        <MDTypography color={"error"} fontSize={pxToRem(12)} sx={{ margin: "0 12px" }}>
          {helperText}
        </MDTypography>
      )}
    </>
  );
}
